import { userProfile } from './profilesIndex';

export function dateTimeUtils(hour: string) {
  let parseHour = '';
  hour = returnTimeToSendFormat(hour);
  if (hour.length === 3) {
    parseHour = checkHour(hour[0]) + ':' + checkMinutes(hour[1] + '' + hour[2]);
  } else if (hour.length === 4) {
    parseHour =
      checkHour(hour[0] + hour[1]) +
      ':' +
      '' +
      checkMinutes(hour[2] + '' + hour[3]);
  } else if (hour.length === 5) {
    parseHour = hour.substring(1);
    parseHour =
      checkHour(parseHour[0] + parseHour[1]) +
      ':' +
      '' +
      checkMinutes(parseHour[2] + '' + parseHour[3]);
  } else if (hour.length > 5) {
    parseHour = returnTimeToSendFormat(hour);
    parseHour = parseHour.substring(1);
    parseHour =
      checkHour(parseHour[0] + parseHour[1]) +
      ':' +
      '' +
      checkMinutes(parseHour[2] + '' + parseHour[3]);
  } else {
    parseHour = hour;
  }
  return parseHour;
}

export function timestampToTimeString(timestamp: number): string {
  const date = new Date(timestamp);
  const time = `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;
  return time;
}

export function returnTimeToSendFormat(hour: string) {
  return hour.replace(':', '');
}

function checkHour(hour: string) {
  const numberHour = Number(hour);
  let returnalHour = '';
  if (numberHour > 0 && numberHour < 10) {
    returnalHour = ('0' + numberHour).toString();
  } else if (numberHour > 9 && numberHour < 25) {
    returnalHour = hour.toString();
  } else {
    returnalHour = '00';
  }
  return returnalHour;
}

export function extendEndDay(hour: string) {
  const date = new Date(hour);
  date.setHours(23, 59, 59, 999);

  return date.getTime();
}

function checkMinutes(minutes: string) {
  const numberMinutes = Number(minutes);
  let returnalMinutes = '';

  if (numberMinutes > 0 && numberMinutes < 10) {
    returnalMinutes = ('0' + numberMinutes).toString();
  } else if (numberMinutes >= 10 && numberMinutes < 60) {
    returnalMinutes = numberMinutes.toString();
  } else {
    returnalMinutes = '00';
  }
  return returnalMinutes;
}

/**
 *
 * @param date {string, Date, number} to format a Date. Must be a format available to Date.
 * @param time {string} time in format hhmm or hh:mm
 * @return {number} the number of milliseconds of the resultant date
 */
export function generateTimeStamp(date: any, time: any): number {
  const updateDate = new Date(Number(date));
  let newDateMilliseconds: any;

  if (time.length === 5) {
    const hours = time.slice(0, 2);
    const minutes = time.slice(3, 5);
    updateDate.setHours(Number(hours), Number(minutes), Number(0));
    newDateMilliseconds = Math.floor(updateDate.getTime());
  }
  if (time.length === 4) {
    const hours = time.slice(0, 1);
    const minutes = time.slice(2, 3);
    updateDate.setHours(Number(hours), Number(minutes));
    newDateMilliseconds = Math.floor(updateDate.getTime());
  }
  return newDateMilliseconds;
}

/**
 * Extract the time from a Date.
 * @param date {Date} the date to format
 * @param dots=false {boolean} if put the dots. By default is false, so the
 * string result will be in format hhmm. If this parameter is true the resultant
 * format will be hh:mm
 */
export const getTimeFromDate = (date: Date, dots = false): string =>
  `${date.getHours().toString().padStart(2, '0')}${dots ? ':' : ''}${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;

/**
 * Compose the newDate object with the time of the other.
 * This object dont needs to return because is passed by reference
 * @param newDate {Date} the date to compose
 * @param oldDateTime {Date} the date from extract the time
 */
export const composeDateToDateTime = (newDate: Date, oldDateTime: Date) => {
  newDate.setHours(oldDateTime.getHours());
  newDate.setMinutes(oldDateTime.getMinutes());
  newDate.setMilliseconds(oldDateTime.getMilliseconds());
};

export const removeSecondsAndMilliseconds = (date: Date): void => {
  date.setSeconds(0, 0);
};
export const removeTime = (date: Date): void => {
  date.setHours(0, 0);
  removeSecondsAndMilliseconds(date);
};

export const getCellClassName = (curso, user): string => {
  const todayMinus15days = new Date();
  todayMinus15days.setDate(todayMinus15days.getDate() - 15);

  return curso.ID_ESTADO === 'FI' &&
    (user.ID_PERFIL === userProfile.gestor ||
      user.ID_PERFIL === userProfile.administrador) &&
    todayMinus15days.getTime() > curso.FECHA_FIN_CURSO
    ? 'test-class-name'
    : '';
};

/** Modify hours to 23:59 and return TimeStamp with this hour */
export const formatDateMax = (date: number) => {
  const formatDate = new Date(date);
  formatDate.setHours(23, 59, 59, 999);
  return formatDate.getTime();
};

/** Convert minutes to hour and return string*/
export const parseMinutestoHour = (minutes: number) => {
  let result: string = '0';
  if (minutes > 0) {
    result = Math.trunc(minutes / 60).toString();
  }

  return result;
};
